(function () {
    'use strict';

    angular
        .module('componentVisualGuidelinesControllers')
        .controller('VisualGuidelinesComponentPickerDepartmentRiskController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {

        $scope.pickerDepartmentRisk = {};

        $scope.selectRisk = function (risk) {
            $scope.pickerDepartmentRisk.Risk = risk;
        }
    }
})();